var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGeneralMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 0C4.98 0 .5 4.48.5 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm1 15h-2v-2h2v2Zm0-4h-2V5h2v6Z",
  fill: "#FF8A00"
})));
export default SvgGeneralMark;